import SupremeGolfApiClient from './SupremeGolfApiClient';

const TEE_TIME_RECOMMENDATION = 'v6/failure_recommendation/tee_times';
const COURSE_RECOMMENDATION = 'v6/failure_recommendation/courses';

export default class RecommendationApi {
  static async getRecommendedTeeTimes({ teeTimeId, qty = 1, limit = 4 }) {
    const response = await SupremeGolfApiClient.get(TEE_TIME_RECOMMENDATION, {
      teeTimeId,
      qty,
      limit,
    });

    return response.data;
  }

  static async getRecommendedCourses({ courseId = '', date, limit = 4 }) {
    const response = await SupremeGolfApiClient.get(COURSE_RECOMMENDATION, {
      courseId, date, limit,
    });

    return response.data;
  }
}
